export const PAGE_NOTE = "Ops issues every contract. Upload a brand's agreement, then send it to the brand's publishers — all at once or one by one. The brand signs each one, then the publisher.";
